import axios, { AxiosError } from 'axios';

export default class ApiService {

    static activeRequests = {};

    static async get(url, params) {
        const cacheKey = `${url}:${JSON.stringify(params)}`;

        // Verifica se a chave já está sendo processada
        if (this.activeRequests[cacheKey]) {
            //console.log(`Request for ${cacheKey} is already in progress`);
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (!this.activeRequests[cacheKey]) {
                        clearInterval(interval);
                        resolve(this.getItemWithExpiry(cacheKey));
                    }
                }, 100); // Verifica a cada 100ms se a chave foi liberada
            });
        }

        // Marca a chave como ativa
        this.activeRequests[cacheKey] = true;
        const cachedData = await this.getItemWithExpiry(cacheKey);

        if (cachedData) {
            //console.log('[Cache Hit] Data retrieved from cache for:', cacheKey);
            delete this.activeRequests[cacheKey]; // Libera a chave
            return cachedData; // Retorna dados do cache se disponível e não expirado
        }

        try {
            //console.log('[API Call] Making API call for:', cacheKey);
            const response = await axios.get(url, { params });
            await this.setItemWithExpiry(cacheKey, response.data, 5000); // Salva no cache por 5 segundos
            delete this.activeRequests[cacheKey]; // Libera a chave
            return response.data;
        } catch (error) {
            delete this.activeRequests[cacheKey]; // Libera a chave em caso de erro
            return this.handleAxiosError(error);
        }
    }


    static async post(url, data) {
        try {
            const response = await axios.post(url, { data });
            return response.data;
        } catch (error) {
            return this.handleAxiosError(error)
        }
    }

    static async put(url, data) {
        try {
            const response = await axios.put(url, data);

            if (!response.data.id && response.data.id) {
                return { erro: { message: "Unable to update record" } }
            }
            return response.data;

        } catch (error) {
            return this.handleAxiosError(error)
        }
    }

    static async store(url, data) {
        try {
            const response = await axios.post(url, { data });

            if (!response.data.id && response.data.id) {
                return { erro: { message: "Unable to create record" } }
            }
            return response.data;

        } catch (error) {
            return this.handleAxiosError(error)
        }
    }

    static async update(url, data) {
        try {
            const response = await axios.put(url, data);

            if (!response.data.id && response.data.id) {
                return { erro: { message: "Unable to update record" } }
            }
            return response.data;

        } catch (error) {
            return this.handleAxiosError(error)
        }
    }

    static async delete(url, data) {
        try {
            const response = await axios.delete(url, { data });
            return response.data;

        } catch (error) {
            return this.handleAxiosError(error)
        }
    }

    static handleAxiosError(error) {

        if (error.code == 'ERR_NETWORK') {
            return { error: 'Network error' }
        }

        else if (error.code == "ERR_BAD_REQUEST") {
            if (error.response.data) {
                return error.response.data;
            }
            return { error: 'Bad request' }
        }

    }

    // Dados do cache
    static getData() {
        const dataString = localStorage.getItem('data');
        let data = dataString ? JSON.parse(dataString) : {};
        if (!data.cache) {
            data.cache = {}; // Inicializa cache se não existir
        }
        return data;
    }

    static setData(data) {
        return new Promise((resolve) => {
            localStorage.setItem('data', JSON.stringify(data));
            resolve();
        });
    }

    static async setItemWithExpiry(key, value, ttl) {
        let data = await this.getData();
        const now = Date.now();
        const item = {
            value: value,
            expiry: now + ttl
        };
        data.cache[key] = item;
        await this.setData(data);
    }

    static async getItemWithExpiry(key) {
        let data = await this.getData();

        if (!data.cache[key]) {
            return null;
        }
        const item = data.cache[key];
        const now = Date.now();
        if (now > item.expiry) {
            delete data.cache[key];
            await this.setData(data);
            return null;
        }
        return item.value;
    }

    static clearCache() {
        let data = this.getData(); // Recupera o objeto data atual
        if (data.cache) {
            data.cache = {}; // Limpa o objeto cache
            this.setData(data); // Salva o objeto data atualizado de volta ao localStorage
        }
    }

}